var React = require('react');

function HardHat (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M0 432v-32a16 16 0 0 1 16-16h480a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M320 80v112l40.81-81.62C430.72 139.08 480 207.75 480 288v64H32v-64c0-80.25 49.28-148.92 119.19-177.62L192 192V80a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16z","className":"fa-primary","key":2})]);
}

HardHat.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = HardHat;

HardHat.default = HardHat;
